/**
 * @copyright Copyright (c) Mathieu Vanbeselaëre
 */

// ** File summary ** //
// => ** Explain here what this code does in the project ** //
//

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(SplitText);
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// *=====================================================================================* //

export const homeAnimations = () => {
    let menu = document.querySelector('.menu');
    let home = document.querySelector('.home');
    let mobile = window.innerWidth <= 768;

    if (home) {
        // ** == A) HERO ANIMATION == ** //
        // * A1) Strucural animations
        let scrollContainer = home.querySelector('.hero-scroll-container');
        let screenContainer = home.querySelector('.hero-screen-container');
        let titlePanel = home.querySelector('.title-panel');
        let revealPanel = home.querySelector('.reveal-panel');

        if (scrollContainer) {
            let scrollContainerEnabled = false;
            let scrollContainerAnim = () => {
                gsap.to(screenContainer, {
                    scrollTrigger: {
                        trigger: scrollContainer,
                        pin: screenContainer,
                        start: 'top top',
                        end: 'bottom bottom',
                        // markers: true,
                    },
                });
            };

            // Safari bugfix: enable the scroll pin after a move, otherwise subtitles tend to disappear..
            window.addEventListener('scroll', () => {
                if (!scrollContainerEnabled) {
                    scrollContainerAnim();
                    scrollContainerEnabled = true;
                }
            });

            gsap.to(titlePanel, {
                height: 0,
                ease: 'linear',
                scrollTrigger: {
                    trigger: titlePanel,
                    start: 'top top',
                    scrub: 0.5,
                    // markers: true,
                },
            });

            gsap.to(revealPanel, {
                height: '100vh',
                ease: 'linear',
                scrollTrigger: {
                    trigger: titlePanel,
                    start: 'top top',
                    scrub: 0.5,
                    // markers: true,
                },
            });

            // Move 'YourTempo' hollow title away
            gsap.to(revealPanel, {
                backgroundColor: '#94c9a9',
                scrollTrigger: {
                    trigger: revealPanel,
                    start: 'bottom top',
                    end: 'bottom+=' + window.innerHeight + ' center',
                    scrub: 1,
                },
            });

            // * A2) Hero title animations (appearing)
            let mainTitle = home.querySelector('.title-img');
            let subtitles = home.querySelector('.subtitles');
            let subtitlesItems = subtitles.querySelectorAll('h3');
            let subtitlesWrapper = subtitles.querySelectorAll('span');
            let clipartsContainers = home.querySelectorAll('.hovering-clipart');
            let cliparts = home.querySelectorAll('.clipart');

            subtitlesWrapper = [...subtitlesWrapper].reverse(); // Reverse that
            cliparts = [...cliparts].reverse(); // Reverse that

            let hero = gsap.timeline({ delay: 0.5 });

            // Hero Timeline //
            hero.to(mainTitle, { autoAlpha: 1, duration: 2, ease: 'power3.inOut' }, 0)
                .to(
                    subtitlesItems,
                    {
                        y: 0,
                        duration: 1.5,
                        autoAlpha: 1,
                        ease: 'power1.out',
                        stagger: .5,
                    },
                    '<+=1.3'
                )
                .to(menu, { y: 0, autoAlpha: 1, duration: .75, onComplete: () => menu.classList.add('menu-visible'), }, '>-=1') // menu
                .to(
                    clipartsContainers,
                    {
                        duration: 5,
                        stagger: 1,
                        opacity: 0.1,
                    },
                    2
                );
            // End Hero Timeline //

            window.addEventListener('DOMContentLoaded', () => hero.play());

            // * A3) Hero title animations (leaving)

            gsap.to(subtitlesWrapper, {
                stagger: 0.01,
                autoAlpha: 0,
                y: 100,
                ease: 'power4.out',
                scrollTrigger: {
                    start: 'top top',
                    end: 'top+=' + window.innerHeight + ' top',
                    trigger: scrollContainer,
                    scrub: 1.4,
                },
            });

            gsap.to(cliparts, {
                stagger: 0.01,
                autoAlpha: 0,
                y: -250,
                ease: 'sine.in',
                scrollTrigger: {
                    start: 'top top',
                    end: 'top+=' + window.innerHeight + ' top',
                    trigger: scrollContainer,
                    scrub: 1.4,
                },
            });
        }

        // ** == B) DESCRIPTION ANIMATIONS == ** //
        let presentationPane = home.querySelector('.presentation-panel');
        let lateralPanel = home.querySelector('.pres-lateral');
        let quote = home.querySelector('.home-quote');

        // * B1) Structural animations
        if (presentationPane) {
            if (!mobile) {
                // Pin the lateral panel
                ScrollTrigger.create({
                    // markers: true,
                    trigger: presentationPane,
                    start: 'top-=50 top',
                    end: 'bottom+=50 bottom',
                    scrub: 0,
                    pin: lateralPanel,
                });

                // Scroll the lateral panel
                gsap.to(lateralPanel, {
                    x: '-' + window.innerWidth / 2,
                    ease: 'linear',
                    scrollTrigger: {
                        // markers: true,
                        trigger: presentationPane,
                        start: 'top top',
                        end: 'bottom bottom+=' + window.innerHeight,
                        scrub: 0.5,
                    },
                });
            }

            // * B2) Element animations

            // Make the description text and logo appear
            let textContainer = home.querySelector('.pres-description');
            if (textContainer) {
                let title = textContainer.querySelector('[data-title]');
                let text = textContainer.querySelector('[data-text]');
                let logo = home.querySelector('.pres-logo img');

                let TL = gsap.timeline({
                    scrollTrigger: {
                        // markers: true,
                        trigger: textContainer,
                        start: mobile ? 'top 66%' : 'top 33%',
                    },
                });

                TL.to(textContainer, {
                    autoAlpha: 1,
                    duration: 2,
                })
                    .to(title, { y: 0 }, '<')
                    .to(text, { y: 0 }, '<')
                    .to(logo, { autoAlpha: 1, duration: 1.5, scale: 1.1, ease: 'power4.out' }, '<+=.5');
            }

            // Reveal the quote
            let splitQuote = new SplitText(quote, { type: 'words' });
            gsap.to(splitQuote.words, {
                duration: 0.01,
                stagger: 0.02,
                color: '#ffffff',
                scrollTrigger: {
                    trigger: presentationPane,
                    // markers: true,
                    start: mobile ? 'top+=' + window.innerHeight + ' 25%' : 'top+=' + window.innerHeight + ' top',
                    end: mobile ? '75% 25%' : 'bottom bottom',
                    scrub: 0,
                },
            });
        }

        // ** == C) PHOTO ALBUM ANIMATIONS == ** //
        // * C1) Photo cover parallax
        let primaryPhoto = document.querySelector('.cover-img');
        if (primaryPhoto) {
            gsap.from(primaryPhoto, {
                x: 75,
                scrollTrigger: {
                    trigger: primaryPhoto,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 0.5,
                    // markers: true,
                },
            });
        }

        let secondaryPhoto = document.querySelector('.cover-img-left');
        if (secondaryPhoto) {
            gsap.to(secondaryPhoto, {
                y: '-100px',
                scrollTrigger: {
                    trigger: secondaryPhoto,
                    start: 'top bottom',
                    end: 'top top',
                    scrub: 0.5,
                    // markers: true,
                },
            });
        }

        // // * C2) Individual photos tilt
        // let allPhotosInTheAlbum = document.querySelectorAll('.album img');
        // if (allPhotosInTheAlbum.length > 0) {
        //     for (let photo of allPhotosInTheAlbum) {
        //         let randomTilt = Math.random() * 11 - 5;
        //         gsap.set(photo, {
        //             rotation: randomTilt
        //         });
        //     }
        // }

        // * C3) Open the album!
        let albumContainer = document.querySelector('.album-container');
        if (albumContainer) {
            // Variables
            let albumPanel = document.querySelector('.album-panel');
            let albumCover = document.querySelector('.cover');
            let coverPhotos = document.querySelector('.cover-photos');
            let albumOpenCta = document.querySelector('.album-cta'); // The button to open the album
            let albumCloseCta = document.querySelector('.album-toggle'); // The div/area to close the album
            let arrow = albumCloseCta.querySelector('.arrow-logo');

            // Reveal timeline
            let revealTimeline = gsap.timeline();
            revealTimeline
                .to(albumCover, {
                    x: '-90%',
                    duration: 1.75,
                    ease: 'power3.inOut',
                })
                .to(
                    coverPhotos,
                    {
                        x: -100,
                        autoAlpha: 0,
                    },
                    '<+=.75'
                )
                .to(
                    albumCloseCta,
                    {
                        onStart: () => {
                            gsap.set(arrow, { rotation: -180 }), (albumCloseCta.style.pointerEvents = 'all');
                            albumCloseCta.style.cursor = 'pointer';
                        },
                        duration: 1,
                        autoAlpha: 1,
                    },
                    '<'
                )
                .to(
                    arrow,
                    {
                        rotation: 0,
                        ease: 'back.inOut(2)',
                    },
                    '>-=.4'
                );

            revealTimeline.pause();

            // Reveal action
            if (albumOpenCta) {
                albumOpenCta.addEventListener('click', () => {
                    albumContainer.setAttribute('data-open', 'true');
                    revealTimeline.play();
                    gsap.to(window, {
                        scrollTo: albumPanel,
                        onComplete: () => {
                            gsap.set(window, { srollTo: albumPanel });
                            document.body.style.overflow = 'hidden';
                            menu.classList.remove('menu-visible');
                        },
                    });
                });

                // Hide action
                albumCloseCta.addEventListener('click', () => {
                    albumContainer.setAttribute('data-open', 'false');
                    revealTimeline.reverse();
                    document.body.style.overflow = 'auto';
                });
            }
        }

        // ** == D) EVENTS ANIMATIONS == ** //
        // * D1) Floating event main title
        let eventTitle = document.querySelector('.events-title');
        if (eventTitle) {
            gsap.from(eventTitle, {
                y: 42,
                scrollTrigger: {
                    trigger: eventTitle,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 0.5,
                    // markers: true,
                },
            });
        }

        // * D2) Events entering (left and right)
        let eventWrapper = document.querySelector('.events-wrapper');
        if (eventWrapper) {
            let mainEvent = document.querySelector('.main-event');
            if (mainEvent) {
                gsap.from(mainEvent, {
                    autoAlpha: 0,
                    x: '-50%',
                    duration: 2,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: eventWrapper,
                        start: 'top center',
                    },
                });
            }

            let otherEvents = document.querySelectorAll('.future-event');
            if (otherEvents.length > 0) {
                gsap.from(otherEvents, {
                    autoAlpha: 0,
                    x: '50%',
                    stagger: .1,
                    duration: 2,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: eventWrapper,
                        start: 'top center',
                    },
                });
            }
        }

        // ** == E) CONTACT ANIMATIONS == ** //
        let contactContainer = document.querySelector('.contact-container');
        if (contactContainer) {
            gsap.to(contactContainer, {
                autoAlpha: 1,
                width: '100%',
                borderRadius: 0,
                ease: 'linear',
                scrollTrigger: {
                    start: 'top bottom',
                    end: 'top 66%',
                    scrub: 1,
                    trigger: contactContainer,
                },
            });
        }
    }
};
